import { toast } from "react-toastify";
import baseApi from "../../../API/baseApi";
import routes from "../../../API/routes";

export async function listarTodosSegurados() { 
    try {
        const response = await baseApi.get(`${routes.segurado.base}`);  

        if(response.data.success){
            return response.data.data;
        }else{
            toast.error(response.data.message || 'Ocorreu um erro ao listar os segurados');
            return [];
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao listar os segurados');
        return [];
    } 
}

export async function buscarSeguradoPorCPF(cpf) {       
    try {
        const response = await baseApi.get(`${routes.segurado.base}/${cpf}`); 

        if(response.data.success){
            return response.data.data;
        }else{
            toast.error(response.data.message || 'Ocorreu um erro ao buscar o segurado');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao buscar o segurado');
        return null;
    } 
}

export async function cadastrarSegurado(dados) {     
    try {
        const response = await baseApi.post(`${routes.segurado.base}`, dados);

        if(response.data.success){
            toast.success(response.data.message || 'Segurado cadastrado com sucesso');
            return { sucesso: true };
        }else{
            toast.error(response.data.message || 'Ocorreu um erro ao cadastrar o segurado');
            return { sucesso: false, mensagem: response.data.message ?? 'Ocorreu um erro ao cadastrar o segurado' };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao cadastrar o segurado');
        return { sucesso: false, mensagem: errorMessage ?? 'Ocorreu um erro ao cadastrar o segurado' };
    } 
}

export async function editarSegurado(dados) {     
    try {
        const response = await baseApi.put(`${routes.segurado.base}`, dados);

        if(response.data.success){
            toast.success(response.data.message || 'Segurado alterado com sucesso');
            return { sucesso: true };
        }else{
            toast.error(response.data.message || 'Ocorreu um erro ao alterar o segurado');
            return { sucesso: false };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao alterar o segurado');
        return { sucesso: false };
    } 
}

export async function excluirSegurado(cpf) {   
    try {
        const response = await baseApi.deletar(`${routes.segurado.base}/${cpf}`);

        if(response.data.success){
            toast.success(response.data.message || 'Segurado excluído com sucesso');
            return { sucesso: true };
        }else{
            toast.error(response.data.message || 'Ocorreu um erro ao excluir o segurado');
            return { sucesso: false };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao excluir o segurado');
        return { sucesso: false };
    }   
}

export async function checaExibicaoMensagemImportacaoFontes(cpf) {   
    try {
        const response = await baseApi.get(`${routes.segurado.base}/${routes.segurado.checarExibicaoMensagemImportacaoFontes}/${cpf}`);

        if(response.data.success)
            return response.data.data

        return false;
    } catch (e) {
        return false;
    }   
}

export async function confirmarMensagemImportacaoFontes(cpf) {   
    try {
        const response = await baseApi.put(`${routes.segurado.base}/${routes.segurado.confirmarMensagemImportacaoFontes}/${cpf}`);
        return response.data.success;
    } catch (e) {
        return false;
    }   
}


  